import AbstractModal from './AbstractModal';

export default class extends AbstractModal {
    constructor(m) {
        super(m);

        this.$input = this.$('input')[0]
    }

    init() {
        super.init();
    }

    bindEvents() {
        super.bindEvents();

        window.addEventListener('keydown',this.onKeyShortcut)
    }

    unbindEvents() {
        super.unbindEvents();

        window.removeEventListener('keydown',this.onKeyShortcut)
    }

    onKeyShortcut = (e) => {
        if((e.metaKey || e.ctrlKey) && e.code == 'KeyK') {
            this.toggle();
        }
    }

    onPostActivate() {
        this.$input?.focus();
        this.$input?.setSelectionRange(this.$input.value.length, this.$input.value.length);
    }
}
